import React, { useEffect, useState } from "react";
import { FilterBar, TableData } from "../../components";
import { useDispatch } from "react-redux";
import { getConciliacionDiariaReportService } from "../../services/report/reportService";
import { errorAlert } from "../../helpers/alerts";
import moment from "moment";
import { setTitle } from "redux/slices/uiSlice";
import { Box } from "@mui/material";
import Images from "assets/images";
import { useNavigate } from "react-router-dom";
import Image from "components/common/Image";


const ConciliacionDiariaScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({})

  const columns = [
    { name: "datetime", label: "Fecha", sort: ({ date }) => date, format: ({ date }) => date },
    { name: "total", label: "No. Conciliaciones", format: ({ count }) => count },
    { name: "sinRegistros", label: "Sin Registros", format: ({ withoutRecords }) => withoutRecords },
    { name: "correctas", label: "Conciliado", format: ({ correct }) => correct },
    { name: "diferencia", label: "Con Diferencias", format: ({ withDiff }) => withDiff },
    { name: "error", label: "Errores", format: ({ error }) => error },
    { name: "result", label: "Resultado", format: ({ result }) => result },
  ].filter(Boolean);

  useEffect(() => {
    dispatch(setTitle('Reporte de Conciliacion Diaria'));
  }, []);


  const handlerSubmit = async (data) => {
    setLoading(true)
    setFilters(data)
    getConciliacionDiariaReportService(data).then((result) => {
      setList(result)
    }).catch((error) => errorAlert(error))
      .finally(() => setLoading(false));
  }

  const handlerDay = async (data) => {
    navigate("/admin/proveedores/conciliaciones", { state: { date: data.date } });
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        validateButton={(fields) => !(fields.commerce && fields.date)}
        defaultValues={{
          date: moment().toDate(),
        }}
        // allValue={null}
        filters={[
          {
            type: "month",
            name: "date",
            label: "Mes",
          },
        ]}
      />
      <Box mt={2}>
        <TableData
          loading={loading}
          headerButtons={[
            // <CustomButton
            //   dark={true}
            //   icon={Images.icon.download}
            //   key="dowloadDetails"
            //   name={"Descargar"}
            //   loading={loading}
            //   click={handlerDownload}
            // />,
          ]}
          dataRows={list}
          dataTitle={columns}
          formatter={(data) => columns.map(({ format }) => format(data))}
          actions={[
            {
              label: "Reporte",
              icon: <Image src={Images.icon.arrow_next} alt="reporte" />,
              onClick: (data) => handlerDay(data)
            },
          ]}
        />
      </Box>
    </>
  );
};

export default ConciliacionDiariaScreen;
